import { BarcodeAPI } from './Barcode'
import { ProfileAPI } from './Profile'
import { API } from './types'

export class Base {
  api: API

  constructor(api: API) {
    this.api = api
  }

  get barcodes() {
    const api = new BarcodeAPI(this.api)
    Object.defineProperty(this, 'barcodes', { value: api })
    return api
  }

  get profiles() {
    const api = new ProfileAPI(this.api)
    Object.defineProperty(this, 'profiles', { value: api })
    return api
  }
}
